export enum CompanionType {
  default = 'CABIN_BNO',
  cabinBNO = 'CABIN_BNO',
  diningWith = 'DINING_WITH',
}
